import gql from "graphql-tag";
import { userFieldsFragment } from "../user/user.gql";

export const channelFieldsFragment = gql`
    fragment channelFields on Channel {
        id
        name
        description
        admins {
            ...userFields
        }
        cover {
            id
            url
            type
            createdAt
            updatedAt
        }
        createdAt
        updatedAt
    }

    ${userFieldsFragment}
`;

export const channelsQuery = gql`
    query Channels($pagingInput: PagingInput) {
        channels(pagination: $pagingInput) {
            data {
                id
                name
                cover {
                    url
                }
            }
            pagingMeta {
                count
                startIndex
                endIndex
                hasNextPage
            }
        }
    }
`;

export const channelQuery = gql`
    query Channel($id: String!) {
        channel(id: $id) {
            ...channelFields
        }
    }
    ${channelFieldsFragment}
`;
